import React from 'react'
import AppPageComponent from '@components/page/appPage.component'
import PageHeaderComponent from '@components/page/pageHeader.component'

const NotFoundPage = () => (
  <AppPageComponent>
    <PageHeaderComponent>
      <h1>404 - Not Found</h1>
    </PageHeaderComponent>
  </AppPageComponent>
)

export default NotFoundPage
